{{#if interface.hasResetAndOtherPorts}}
{{#with interface.resetPort}}
virtual task wait_for_reset_to_deassert();
  wait ({{ identifier }} === {{#if activeLow}}1{{else}}0{{/if}});
endtask
{{/with}}
{{/if}}
